const keywords = {
    bots_crawlers: {
        title: 'Bots & Crawlers',

        description: `<b>(this data is not included in other stats)</b><br/>Bots are nonhuman traffic sources that generate page views, visits, and other site activity. Crawlers are specific code/programs that ‘crawl’ websites to determine what information exists and is relevant on a site to help people find what they are looking for when searching online.`,
    },
    contact_forms_sent: {
        title: 'Contact Forms Sent',

        description: `The number of times a site visitor filled out the 'Contact Us' form and the 'Send Email or Send' button was used to send you an email from your page.`,
        notes: [
            `Emails are sent by Mirus directly to the <strong>agent’s</strong> Desjardins Outlook email address.`,
        ],
    },
    links_clicked_to_external_sites: {
        title: 'Links Clicked to External Sites',

        description: `The site visitor ‘clicks’ a link, button, image, etc. on your page which takes them to the external website shown in the list provided.`,
    },
    map_directions_clicks: {
        title: 'Map & Directions Clicks',

        description: `The number of times a site visitor clicks on the map image or 'Map & Directions' link to get directions to your office.`,
        notes: [
            `If you have a banner map image displaying at the top of your EM site, it is a static image that is not clickable or counted in the metrics.`,
        ],
    },
    page_view: {
        title: 'Page Views',

        description: `Number of times your page was viewed, by real human visitors (not bots). A page view is counted each time a site visitor lands on or refreshes your page.`,
        examples: [
            `If a site visitor lands on your page, then refreshes the page 4 times, the dashboard will show 1 Visit and 4 Page Views.`,
        ],
    },
    page_views_by_device_type: {
        title: 'Page Views by Device Type',

        description: `Depicts a pie chart that shows the number of Page Views by device type for the time frame chosen. Hover over the 'piece of the pie' in the graph to see each device type’s specific number of Page Views.`,
    },
    page_views_by_referrer: {
        title: 'Page Views by Referrer',

        description: `Various sites can be listed here, based on where (what website) the site visitor was viewing, prior to clicking on something on that site, that brought them to your page. You will most often see google.com (since it is the most used search engine).`,
    },
    page_views_over_time: {
        title: 'Page Views Over Time',

        description: `Depicts a line graph that shows the number of Page Views by day for the time frame chosen. Hover over the 'dot' in the graph to see that day’s specific number of Page Views.`,
    },
    phone_clicks: {
        title: 'Phone Clicks',

        description: `
	The number of times a site visitor clicked on your phone number from anywhere that it is displayed on your page. When a site visitor 'clicks' on your phone number, it does not mean they actually called your office. The person may not have not hit the ‘call’ button from their mobile device or they may have clicked your phone number on a desktop device that they could not make a call from.
	`,
    },
    quote_starts: {
        title: 'Quote Starts',

        description: `Number of times the 'Get Quote' or ‘Start Quote’ button, in the Quote Module, on your page was clicked to start a quote. This does not mean the quote was actually started on desjardins.com or that the quote turned into a lead. Mirus is <b>not currently</b> privy to what happens after a site visitor leaves your page or to any quote start/complete data captured by Desjardins.`,
        examples: [
            `If a site visitor types in their postal code in the Quote Module and clicks ‘Get Quote’, this will count as 1 Quote Start.`,
        ],
        notes: [`Clicks to “Continue a Saved Quote” are not counted as Quote Starts`],
    },
    review_clicks: {
        title: 'Review Clicks',

        description: `
	The number of times a site visitor clicks on the Google review link for your office.
	`,
    },
    visits: {
        title: 'Visits',

        description: `The number of unique/distinct real human site visitors who visited your page within a 24 hour period. The number of Visits will almost always be less than the number of Page Views.`,
        examples: [
            `If a site visitor lands on your page, then refreshes the page 4 times, the dashboard will show 1 Visit and 4 Page Views.`,
        ],
    },
    your_page: {
        title: 'Your Page',

        description: `Refers to <i>your domain URL</i> (e.g. www.myauroraagent.com). If you have more than one domain, all data is added together and shown on your dashboard.`,
    },
    cmpid: {
        title: ' Campaign IDs',
        description: `Campaign IDs or cmpids are a series of specific numeric/alpha characters added to the end of your EM domain and/or Quote Landing page URLs that allow you to track different digital advertising campaigns and tactics. If Campaign IDs are not set up and attached to the URL properly, detailed campaign reporting cannot be provided. Use the Link Generator to assist you in generating a URL with a Campaign ID attached.`,
        notes: [
            `Mirus captures and provides you detailed Campaigns data for all types of Campaign IDs that have been added to your URL(s). Mirus has no knowledge of which marketing vendor or what digital advertising campaigns and tactics are represented by the Campaign IDs you may have.`,
        ],
    },
};

const sortObject = (obj) =>
    Object.keys(obj)
        .sort()
        .reduce((res, key) => ((res[key] = obj[key]), res), {});

export default sortObject(keywords);
